import { DocumentReference } from '.';

export class MemberReference extends DocumentReference {
    isSynced?: boolean;
}